import PropTypes from "prop-types";
import Modal from "@/common/elements/Modal";

const CustomModal = ({
  children,
  header,
  show,
  onHide,
  size = "md",
  onSaveClick,
  onCloseClick,
  submitButtonText = "Save",
  closeButtonText = "Cancel",
  hideFooter = false,
  hideSavebutton = false,
  modalFormMode = "default",
  backdrop = true,
  isAPICall = false,
  isDisabled=false
}) => {
  // Handlers for modal actions
  const handleModalHide = () => {
    if (onCloseClick) onCloseClick();
    if (onHide) onHide();
  };

  const handleSaveClick = () => {
    if (onSaveClick) onSaveClick();
  };

  // Dynamically construct modal class names
  const modalClassName = [
    "default",
    modalFormMode === "add" && "add-form-modal",
    modalFormMode === "edit" && "edit-form-modal",
  ]
    .filter(Boolean)
    .join(" ");

  return (
    <Modal 
      className={modalClassName}
      header={header}
      show={show}
      onHide={handleModalHide}
      size={size}
      backdrop={backdrop}
      footerActionsNeed={hideFooter?false:true}
      footerActions={
        !hideFooter || !hideSavebutton
          ? [
              {
                key: "save",
                text: submitButtonText,
                onClick: handleSaveClick,
                loading: isAPICall,
                disabled:isDisabled
              },
            ]
          : null
      }
      footerCloseAction={!hideFooter}
      footerCloseActionText={!hideFooter ? closeButtonText : null}
    >
      {children}
    </Modal>
  );
};
export default CustomModal;
